<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px;">
      <a-tab-pane key="storerTable" :tab="$t('tab.storerData')" style="margin-top: -14px">
        <storer-table ref="storerTable" @dblClick="dblClick"/>
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" size="mini" status="primary" @click="refresh"/>
        <vxe-button content="button.add" icon="vxe-icon-add" size="mini" status="primary" @click="add"/>
        <vxe-button content="button.save" icon="vxe-icon-save" size="mini" status="primary" @click="save"/>
      </a-space>
    </a-tabs>
  </a-layout>
</template>
<script>
import StorerTable from '@/views/basedata/storer_maintenance/StorerTable.vue'

export default {
  name: 'StorerBaseData',
  components: { StorerTable },
  data() {
    return {
      activeKey: 'storerTable'
    }
  },
  methods: {
    dblClick(record) {
    },
    add() {
      this.$refs[this.activeKey].add()
    },
    save() {
      this.$refs[this.activeKey].save()
    },
    refresh() {
      this.$refs[this.activeKey].refresh()
    }
  }
}
</script>